import './HeatPumpEnergyFlow.css';

interface HeatPumpEnergyFlowProps {
  animated?: boolean;
  printMode?: boolean;
  className?: string;
}

export function HeatPumpEnergyFlow({
  animated = true,
  printMode = false,
  className = '',
}: HeatPumpEnergyFlowProps) {
  const shouldAnimate = animated && !printMode;

  return (
    <figure
      className={`hp-energy-flow ${shouldAnimate ? 'hp-energy-flow--animated' : ''} ${printMode ? 'hp-energy-flow--print' : ''} ${className}`}
    >
      <svg
        className="hp-energy-flow__svg"
        viewBox="0 0 640 220"
        role="img"
        aria-labelledby="hp-energy-flow-title hp-energy-flow-desc"
      >
        <title id="hp-energy-flow-title">Where the heat comes from in a heat pump</title>
        <desc id="hp-energy-flow-desc">
          Outdoor air provides most heat, electricity powers the compressor, and useful heat flows into the home.
        </desc>

        <defs>
          <marker id="hp-arrow-air" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto">
            <path d="M0,0 L6,3 L0,6 Z" className="hp-energy-flow__air" />
          </marker>
          <marker id="hp-arrow-heat" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto">
            <path d="M0,0 L6,3 L0,6 Z" className="hp-energy-flow__heat" />
          </marker>
          <marker id="hp-arrow-electric" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto">
            <path d="M0,0 L6,3 L0,6 Z" className="hp-energy-flow__electric" />
          </marker>
        </defs>

        {/* Outdoor air arrows */}
        <line
          x1="60"
          y1="60"
          x2="250"
          y2="60"
          className="hp-energy-flow__air hp-energy-flow__air-1"
          markerEnd="url(#hp-arrow-air)"
        />
        <line
          x1="40"
          y1="100"
          x2="250"
          y2="100"
          className="hp-energy-flow__air hp-energy-flow__air-2"
          markerEnd="url(#hp-arrow-air)"
        />
        <line
          x1="70"
          y1="140"
          x2="250"
          y2="140"
          className="hp-energy-flow__air hp-energy-flow__air-3"
          markerEnd="url(#hp-arrow-air)"
        />

        {/* Electricity input */}
        <line
          x1="220"
          y1="190"
          x2="310"
          y2="150"
          className="hp-energy-flow__electric"
          markerEnd="url(#hp-arrow-electric)"
        />

        {/* Heat pump box */}
        <rect x="260" y="50" width="120" height="120" rx="10" className="hp-energy-flow__pump" />
        <text x="320" y="115" textAnchor="middle" className="hp-energy-flow__pump-label">
          Heat pump
        </text>

        {/* Warmth into home */}
        <line
          x1="390"
          y1="100"
          x2="560"
          y2="100"
          className="hp-energy-flow__heat hp-energy-flow__heat-line"
          markerEnd="url(#hp-arrow-heat)"
        />

        {/* Home */}
        <rect x="565" y="80" width="50" height="45" rx="4" className="hp-energy-flow__home" />
        <polygon points="565,80 590,55 615,80" className="hp-energy-flow__home" />

        {/* Labels */}
        <text x="60" y="30" className="hp-energy-flow__label">
          Low-grade heat from outdoor air
        </text>
        <text x="170" y="205" className="hp-energy-flow__label hp-energy-flow__label-electric">
          Electricity to run the compressor
        </text>
        <text x="420" y="30" className="hp-energy-flow__label hp-energy-flow__label-heat">
          Useful heat delivered to your home
        </text>
      </svg>
      <figcaption className="hp-energy-flow__caption">
        Most of the heat comes from outside — electricity just drives the process.
      </figcaption>
    </figure>
  );
}

export default HeatPumpEnergyFlow;
